"use client";

import React from "react";
import { SwitchCallback, SwitchCallbackMouseEvent } from "../types";

type Props = {
  prompt: string;
  linkText: string;
  onSwitch: SwitchCallback;
  isModal?: boolean;
  onAnalyticsClick?: () => void;
};

const FormSwitchLink: React.FC<Props> = ({
  prompt,
  linkText,
  onSwitch,
  isModal = false,
  onAnalyticsClick,
}) => {
  const handleClick = (e: SwitchCallbackMouseEvent) => {
    onAnalyticsClick?.();
    onSwitch(e, isModal);
    if (typeof window !== "undefined") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <div className="flex gap-1">
      <span className="text-md font-bold text-gray-800">{prompt}</span>
      <button
        onClick={handleClick}
        className="text-md font-bold text-info-500 cursor-pointer underline"
      >
        {linkText}
      </button>
    </div>
  );
};

export default FormSwitchLink;
